/**
 * @generated SignedSource<<49dc8006427bac89159d8f80986ee3a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BlogPostQueryInput = {
  slug: string;
};
export type BlogPostQuery$variables = {
  input: BlogPostQueryInput;
};
export type BlogPostQuery$data = {
  readonly blogPost: {
    readonly content: string;
    readonly date: string;
    readonly description: string;
    readonly id: string;
    readonly imageUrl: string | null;
    readonly title: string;
  } | null;
};
export type BlogPostQuery = {
  response: BlogPostQuery$data;
  variables: BlogPostQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BlogPost",
    "kind": "LinkedField",
    "name": "blogPost",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogPostQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BlogPostQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9434bccfaf05d8a5345efd2efba22e60",
    "id": null,
    "metadata": {},
    "name": "BlogPostQuery",
    "operationKind": "query",
    "text": "query BlogPostQuery(\n  $input: BlogPostQueryInput!\n) {\n  blogPost(input: $input) {\n    id\n    title\n    imageUrl\n    content\n    description\n    date\n  }\n}\n"
  }
};
})();

(node as any).hash = "99fd2263e8f1bb4474b9839580cb8703";

export default node;
